import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import Endpoints from '../endpoints';
import { StatisticsDTO } from '../types/statistics';
import { LiveViewDTO } from '../types/common';

@Injectable()
export class StatisticsService {
  constructor(private http: HttpClient) { }

  public getStatistics(params: any): Observable<StatisticsDTO> {
    return this.http.get<StatisticsDTO>(Endpoints.GET_STATISTICS, { params: params });
  }

  public exportStatistics(params: any): Observable<any> {
    return this.http.get(Endpoints.EXPORT_STATISTICS, { params: params, responseType: 'blob' });
  }
}
